
    <favorite-list-confirm-close
        [show]="showConfirmCloseBeforeSave"
        (onClose)="closeDialog()"
        (onConfirm)="confirmDialogVerification()"
    ></favorite-list-confirm-close>
    <ev-dialog [visible]="showConfirmDialog" (close)="closeDialog()" (confirm)="confirmDialogVerification()" [maxWidth]="'460px'" [title]="'Slett'">
        <p class="dialog-content-text">Er du sikker på at du vil slette denne listen?</p>
    </ev-dialog>
    <div class="favorite-list-wrapper" [class.expanded]="isExpanded">
        <div class="favorite-list-header" [class.active]="showDialog">
            <h1>
                Lister:&nbsp;<span class="header-object-type">{{ listHeaderTypeName() }}</span>
            </h1>
            <div class="favorite-list-close" (click)="onCloseSideBar()"></div>
        </div>
        <div class="favorite-list-content" [class.is-favorite-open]="isInFavoriteOpenState()">
            @if(isInOverviewState()) {
            <div class="overview row">
                <div class="empty-list-wrapper quick-choice-bottom">
                    <div class="quickies">
                        <div class="header-info-text">
                            {{ sales() !== null && sales().length > 0 ? sales().length : "Ingen " }} {{ listEstateDescription() }} i
                            utvalg
                        </div>
                        @if(sales() !== null && sales().length > 0) {
                        <div
                            
                            class="icon-btn download"
                            (click)="exportLongSaleToExcel()"
                        >
                            Eksporter utvalg til Excel
                        </div>
                        <div
                            
                            class="icon-btn download"
                            (click)="exportLongSaleToPdf()"
                        >
                            Eksporter utvalg til Pdf
                        </div>
                        <div
                            
                            class="icon-btn create"
                            (click)="newFavoriteList(true)"
                        >
                            Lag ny liste av utvalg
                        </div>
                        }
                        <div
                            
                            (click)="newFavoriteList()"
                            class="icon-btn create-empty"
                        >
                            Lag ny blank liste
                        </div>
                    </div>
                </div>
                <div class="show-all-lists">
                    @if(hasFavoriteLists()) { @for(item of this.overviewFavoriteListsStore.overview(); track item.id; let first = $first) { @if (item.id !== -1)
                    {
                    <div class="item-wrapper margin-top" [class.no-margin]="first">
                        <favorite-list-thumb
                            [overview]="item"
                            (onOpenFavorite)="openFavorite($event)"
                            (onOpenMenu)="openMenu(item.id)"
                            (onCloseMenu)="closeMenu(item.id)"
                        >
                            <favorite-list-menu
                                [selectedId]="item.id"
                                (onOpen)="openFavorite($event)"
                                (onDelete)="deleteFavorite($event)"
                                (onRename)="renameFavorite($event)"
                                (onGotoListMapBounds)="gotoListMapBounds($event)"
                                (onExportSelectionToPdf)="exportSelectionToPdf($event)"
                                (onExportSelectionToExcel)="exportSelectionToExcel($event)"
                            >
                            </favorite-list-menu>
                        </favorite-list-thumb>
                    </div>
                    } } }
                </div>
            </div>
            } @if(isInFavoriteOpenState()) {
            <favorite-list
                [hasSaveRights]="hasFavoriteListSaveRight"
                [mapMode]="this.mapStateService.mapModeSignal()"
                (onSave)="saveFavoriteList()"
                (onClose)="closeFavorite()"
                (onAddAllSelection)="addAllSelection($event)"
                (onOpenMenu)="openMenu($event)"
                (onCloseMenu)="closeMenu($event)"
            >
                <favorite-list-menu
                    [selectedId]="this.selectedFavoriteListStore.id()"
                    (onOpen)="openFavorite($event)"
                    (onRename)="renameFavorite($event)"
                    (onDelete)="deleteFavorite($event)"
                    (onClose)="closeFavorite()"
                    (onAddAllSelection)="addAllSelection($event)"
                    (onGotoListMapBounds)="gotoListMapBounds($event)"
                    (onExportSelectionToPdf)="exportSelectionToPdf($event)"
                    (onExportSelectionToExcel)="exportSelectionToExcel($event)"
                    (onRemoveAllSelection)="removeAllSelection($event)"
                >
                </favorite-list-menu>
            </favorite-list>
            }
            
            @if (this.favoriteListExportService.isGeneratingReportSignal()) {
            <div class="loading-report" [style.transform]="'translateY(0px)'">
                <div class="progress" [style.width]="this.favoriteListExportService.reportProgressSignal()">
                    {{ this.favoriteListExportService.reportProgressSignal() }}
                </div>
            </div>
            }
        </div>
    </div>

